import { render, staticRenderFns } from "./KAM003-v2.vue?vue&type=template&id=407fc11c"
import script from "./KAM003-v2.vue?vue&type=script&lang=ts"
export * from "./KAM003-v2.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports